// Comprobante térmico de CORTE DE CAJA — presentacional puro (oculto en pantalla, visible al imprimir).
// Sprint 41.2 — Usa el modelo ÚNICO del corte (mismo formato que el builder ESC/POS) para que Web
// Terminal/Valet y 58/80mm impriman idéntico. FECHA DE OPERACIÓN = fecha de apertura del turno.
import { buildCorteModel, money } from "@/lib/corteModel";

export const CorteThermalReceipt = ({ corte, paperWidth }) => {
  if (!corte) return null;
  const m = buildCorteModel(corte, { efectivoContado: corte.efectivoContado, reimpresion: corte.reimpresion });
  const sucNombre = corte.sucursalNombre || corte.nombre_sucursal || corte.sucursal_nombre;
  const li = m.liquidacion, im = m.importes, co = m.conciliacion;
  return (
    <div className={`thermal-receipt tr-corte tr-w${paperWidth}`} data-testid="corte-thermal">
      <div className="tr-center tr-brand">{corte.brand || "PARKNOVA"}</div>
      <div className="tr-center tr-bold tr-lg">CORTE DE CAJA</div>
      {sucNombre ? <div className="tr-row tr-sm"><span>Sucursal:</span><span>{sucNombre}</span></div> : null}
      {(corte.operador) ? <div className="tr-row tr-sm"><span>Operador:</span><span>{corte.operador}</span></div> : null}
      <div className="tr-center tr-bold" style={{ marginTop: "6px" }}>FECHA DE OPERACIÓN</div>
      <div className="tr-center tr-bold tr-lg" data-testid="corte-fecha-operacion">{m.operacionFecha}</div>
      <div className="tr-row tr-sm"><span>Inicio de turno:</span><span>{m.inicioTxt}</span></div>
      <div className="tr-row tr-sm"><span>Cierre de turno:</span><span>{m.cierreTxt}</span></div>
      {m.reimpresion ? <div className="tr-center tr-bold tr-sm">** REIMPRESIÓN **</div> : null}
      <div className="tr-sep">--------------------------------</div>

      <div className="tr-bold">LIQUIDACIÓN (TICKETS)</div>
      <div className="tr-row"><span>Tickets generados</span><span>{li.generados}</span></div>
      <div className="tr-row"><span>(-) Cancelados</span><span>{li.cancelados}</span></div>
      <div className="tr-row"><span>(-) Cortesías</span><span>{li.cortesias}</span></div>
      <div className="tr-row tr-bold"><span>Tickets efectivamente cobrados</span><span>{li.cobrados}</span></div>
      <div className="tr-sep">--------------------------------</div>

      <div className="tr-bold">CÁLCULO DE IMPORTES</div>
      <div className="tr-row"><span>Recaudación (efectivo)</span><span>{money(im.efvo)}</span></div>
      <div className="tr-row"><span>(+) Fondo inicial</span><span>{money(im.fondo)}</span></div>
      {im.fr > 0 && (
        <div className="tr-row"><span>(+) Factor de riesgo ({im.frN} x {money(im.frCuota)})</span><span>{money(im.fr)}</span></div>
      )}
      <div className="tr-row tr-bold"><span>(=) Subtotal</span><span>{money(im.subtotal)}</span></div>
      <div className="tr-row"><span>(-) Gastos del turno</span><span>{money(im.gastos)}</span></div>
      <div className="tr-row"><span>(-) Retiro de propinas</span><span>{money(im.propinas)}</span></div>
      <div className="tr-sep">--------------------------------</div>

      <div className="tr-center tr-bold">TOTAL EFECTIVO A ENTREGAR</div>
      <div className="tr-center tr-bold tr-lg" data-testid="corte-total-entregar">{money(m.totalEntregar)}</div>
      <div className="tr-sep">--------------------------------</div>

      <div className="tr-bold">CONCILIACIÓN DE CAJA</div>
      <div className="tr-row"><span>Efectivo esperado</span><span>{money(co.totalEntregar)}</span></div>
      {co.contado != null && (
        <>
          <div className="tr-row"><span>Efectivo contado</span><span>{money(co.contado)}</span></div>
          <div className="tr-row tr-bold"><span>DIFERENCIA</span><span>{money(co.diferencia)}</span></div>
          <div className="tr-center tr-bold">{co.estadoCaja}</div>
        </>
      )}

      {m.conceptos.length > 0 && (
        <>
          <div className="tr-sep">--------------------------------</div>
          <div className="tr-bold">DESGLOSE POR CONCEPTO</div>
          {m.conceptos.map((c) => (
            <div key={c.label} className="tr-row"><span>{c.label}</span><span>{money(c.monto)}</span></div>
          ))}
          {m.pernoctas.n > 0 && (
            <div className="tr-row"><span>(+) Pernoctas ({m.pernoctas.n})</span><span>{money(m.pernoctas.monto)}</span></div>
          )}
        </>
      )}

      <div className="tr-sep">--------------------------------</div>
      <div className="tr-bold">VEHÍCULOS EN PATIO</div>
      <div className="tr-row"><span>Vehículos en patio</span><span>{m.patio.n}</span></div>
      {m.patio.folios.map((f) => (
        <div key={f.folio} className="tr-row tr-sm"><span>{f.folio}{f.placa ? ` / ${f.placa}` : ""}</span><span></span></div>
      ))}

      {m.gastosList.length > 0 && (
        <>
          <div className="tr-sep">--------------------------------</div>
          <div className="tr-bold">GASTOS DEL TURNO</div>
          {m.gastosList.map((g) => (
            <div key={g.id} className="tr-row tr-sm"><span>{g.categoria}{g.concepto ? `: ${g.concepto}` : ""}</span><span>{money(g.monto)}</span></div>
          ))}
          <div className="tr-row tr-bold"><span>Total gastos</span><span>{money(im.gastos)}</span></div>
        </>
      )}

      {m.cancelaciones.rows.length > 0 && (
        <>
          <div className="tr-sep">--------------------------------</div>
          <div className="tr-bold">DESGLOSE DE CANCELADOS / CORTESÍAS</div>
          {m.cancelaciones.rows.map((c, i) => (
            <div key={`${c.folio}-${i}`} className="tr-row tr-sm"><span>{c.folio} · {c.tipo}{c.motivo ? ` · ${c.motivo}` : ""}</span><span></span></div>
          ))}
          <div className="tr-row tr-bold"><span>Total cancelados</span><span>{m.cancelaciones.totalCanc}</span></div>
          <div className="tr-row tr-bold"><span>Total cortesías</span><span>{m.cancelaciones.totalCort}</span></div>
        </>
      )}

      <div className="tr-center tr-bold" style={{ marginTop: "10px" }}>¡GRACIAS!</div>
      <div className="tr-center tr-bold">{corte.brand || "ParkNova"}</div>
    </div>
  );
};

export default CorteThermalReceipt;
